import BuildingValidator from "./BuildingValidator";
import FloorValidator from "./FloorValidator";
import DefaultValidator from "./DefaultValidator";
import WingValidator from "./WingValidator";
import UnitValidator from "./UnitValidator";
import RoomValidator from "./RoomValidator";
import _ from 'lodash'
import BedValidator from "./BedValidator";

const RootValidator = (data, treeData)=>{   
  return  _.get(data.type, "code") === "BUILDING"
        ? BuildingValidator(data, treeData)
        : _.get(data.type, "code") === "FLOOR"
        ? FloorValidator(data, treeData)
        : _.get(data.type, "code") === "WING"
        ? WingValidator(data, treeData)
        : _.get(data.type, "code") === "UNIT"
        ? UnitValidator(data, treeData)
        : _.get(data.type, "code") === "ROOM"
        ? RoomValidator(data, treeData)
        :_.get(data.type, "code") === "BED"
        ? BedValidator(data, treeData)
        : DefaultValidator(data);       

}

export default RootValidator;